<template>
  <div style=" background-color: #FFE1E7;">
    <!-- 手机端 头部开始 -->
    <div class="d-sm-none">
      <!-- 手机端微信浏览器 -->
      <div :style="topback" v-if="weixin && ifMobile">
        <b-container fluid>
          <b-row>
            <b-col cols="3">
              <br />
              <b-img :src="logo" fluid-grow></b-img>
            </b-col>
            <b-col cols="9"> </b-col>
          </b-row>
          <b-row>
            <b-col cols="3"> </b-col>
            <b-col cols="6">
              <b-row>
                <b-col>
                  <b-img :src="h300m" fluid-grow></b-img>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="position-relative">
                  <b-img :src="scan" fluid-grow @click="scancode"></b-img>
                  <b-img class="moveUpdown" :src="line" fluid-grow></b-img>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-img :src="h360m" fluid-grow></b-img>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="3"> </b-col>
          </b-row>
        </b-container>
      </div>

      <!-- 手机端 非微信浏览器 -->
      <div v-else>
        <div :style="MobileTopbg">
          <b-container fluid>
            <b-row>
              <b-col cols="3">
               
                <b-img :src="logo" fluid-grow></b-img>
              </b-col>
              <b-col cols="9"> </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <!-- 头部结束 -->

   
    <!-- 手机端中间部分开始 -->
    <div
      :style="note"
      style="z-index: 1;margin-top:-50px; padding: 55px 0 0;"
      class="d-sm-none"
    >
      <b-container fluid>
        <b-row>
          <b-col md="2" class="d-none d-lg-block"></b-col>
          <b-col md="8">
            <b-container fluid>
              <b-row class="text-center">
                <b-col cols="1"></b-col>
                <b-col cols="10">
                  <div
                    style="
                      border-radius: 8rem;
                      border: #f2708c 3px solid;
                      background-color: #f2708c;
                    "
                  >
                    <b-row>
                      <b-col cols="10">
                        <img
                          src="../assets/page2/水滴 (1).png"
                          width="17rem"
                          style="
                            margin-left: 1rem;
                            margin-top: 0.5rem;
                            position: absolute;
                          "
                        />
                        <input
                          type="text"
                          v-model="txtcode"
                          placeholder="请输入追溯码查询"
                          style="
                            font-size: 14px;
                            height: 100%;
                            width: 100%;
                            border-top-left-radius: 8rem;
                            border-top-right-radius: 0em;
                            border-bottom-right-radius: 0em;
                            border-bottom-left-radius: 8rem;
                            border: none;
                            padding-left:26px;
                          "
                        />
                      </b-col>
                      <b-col cols="1" style="padding: 0px" @click="goto_rst"
                        ><img
                          style="
                            width: 100%;
                            padding: 0px;
                            margin: 0px;
                            padding-top: 0.8rem;
                          "
                          src="../assets/page2/搜索.png"
                        />
                      </b-col>
                      <b-col cols="1"> </b-col>
                    </b-row>
                  </div>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>
              <br /><br />
              <b-row class="text-center">
                <b-col style="color: #b79143; font-size: 16px"
                  >没有追溯码？</b-col
                >
              </b-row>
              <b-row class="text-center">
                <b-col
                  cols="6"
                  style="
                    color: #b79143;
                    font-size: 16px;
                    text-align: right;
                    padding-right: 5px;
                  "
                >
                  您也可以进行</b-col
                >
                <b-col
                  cols="5"
                  style="text-align: left; padding-left: 0px"
                  @click="test_rst"
                >
                  <b-img style="width: 100%" :src="tiyan"></b-img>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>
              <br />
              <b-row class="text-center">
                <b-col cols="2"></b-col>
                <b-col cols="8" :style="title">
                  <div
                    style="
                      font-size: 22px;
                      font-family: SourceHanSansCN;
                      font-weight: bold;
                      color: #ffffff;
                      line-height: 11rem;
                    "
                  >
                    追溯码怎么看？
                  </div>
                  <br />
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <b-row style="color: #f2708c; font-size: 13px;">
                    <b-col cols="4">
                      <div
                        style="
                          background-color: #fff;
                          padding: 15px;
                          border-radius: 5px;
                        "
                      >
                        <b-row>
                          <b-col>
                            <b-img :src="g1" fluid-grow></b-img>
                          </b-col>
                        </b-row>
                        <br />
                        <b-row class="text-center">
                          <b-col style="padding: 0px"> 贴码样式 </b-col>
                        </b-row>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div
                        style="
                          background-color: #fff;
                          padding: 15px;
                          border-radius: 5px;
                        "
                      >
                        <b-row>
                          <b-col>
                            <b-img :src="g2" fluid-grow></b-img>
                          </b-col>
                        </b-row>
                        <br />
                        <b-row class="text-center">
                          <b-col style="padding: 0px"> 刻码样式 </b-col>
                        </b-row>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div
                        style="
                          background-color: #fff;
                          padding: 15px;
                          border-radius: 5px;
                        "
                      >
                        <b-row>
                          <b-col>
                            <b-img :src="g3" fluid-grow></b-img>
                          </b-col>
                        </b-row>
                        <br />
                        <b-row class="text-center">
                          <b-col style="padding: 0px"> 印刷码样式 </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <br /><br /><br />
              <b-row>
                <b-col cols="3"></b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col>
                      <b-img :src="qrcode" fluid-grow></b-img>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col cols="4"></b-col>
                    <b-col cols="4">
                      <b-img :src="arrow" fluid-grow></b-img>
                    </b-col>
                    <b-col cols="4"></b-col>
                  </b-row>
                </b-col>
                <b-col cols="3"></b-col>
              </b-row>
              <b-row class="text-center">
                <b-col
                  style="
                    color: #b79143;
                    font-size: 2rem;
                    font-family: SourceHanSansCN;
                  "
                >
                  扫码查看婴配乳粉溯源</b-col
                >
              </b-row>
              <br /><br />
              <b-row>
				  <!-- <b-img style="width: 272px;height: 25px;" class="footerText m-auto" :src="require('../assets/pc_result/footerText.png')" alt=""></b-img> -->
               
              </b-row>
            </b-container>
          </b-col>
          <b-col md="2" class="d-none d-lg-block"></b-col>
        </b-row>
      </b-container>
      <b-img :src="bottom" fluid-grow></b-img>
    </div>
    <!-- 手机端中间部分结束 -->


     <!-- PC端开始 -->
     <div class="d-none d-sm-block">
      <img src="../assets/pc_scan/top.jpg" style="width: 100%" />
    </div>

    <div :style="note_p" class="d-none d-sm-block" style="padding-bottom: 20rem;">
      <b-container fluid>
        <b-row>
          <b-col md="3"></b-col>
          <b-col md="6">
            <b-container fluid>
              <b-row style="color: #f2708c;padding-bottom: 1rem;">
                <b-col cols="6" style="padding-left: 3rem; font-size: 1.8rem"
                  >追溯码</b-col
                >
                <b-col
                  cols="6"
                  style="
                    text-align: right;
                    padding-right: 1rem;
                    font-size: 1.2rem;
                  "
                >
                </b-col>
              </b-row>
              <b-row class="text-center">
                <b-col>
                  <div
                    style="
                      border-radius: 8rem;
                      border: #f2708c 3px solid;
                      background-color: #f2708c;
                    "
                  >
                    <b-row>
                      <b-col cols="10">
                        <img
                          src="../assets/page2/水滴 (1).png"
                          style="
                            margin-left: 2rem;
                            margin-top: 2%;
                            margin-left: 2%;
                            position: absolute;
                            height: 60%;
                          "
                        />
                        
                        <input
                          type="text"
                          v-model="txtcode"
                          placeholder="请输入追溯码查询"
                          style="
                            font-size: 1.5rem;
                            height: 100%;
                            width: 100%;
                            border-top-left-radius: 8rem;
                            border-top-right-radius: 0em;
                            border-bottom-right-radius: 0em;
                            border-bottom-left-radius: 8rem;
                            border: none;
                            padding-left: 4rem;
                          "
                        />
                      </b-col>
                      <b-col
                        cols="1"
                        style="padding: 0px; cursor: pointer"
                        @click="goto_rst"
                      >
                        <img
                          style="
                            width: 100%;
                            padding: 0px;
                            margin: 0px;
                            padding-top: 0.8rem;
                          "
                          src="../assets/page2/搜索.png"
                        />
                      </b-col>
                      <b-col cols="1"> </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>

              <br /><br /><br />

              <b-row class="text-center">
                <b-col style="color: #b79143; font-size: 1.5rem"
                  >没有追溯码？</b-col
                >
              </b-row>
              <b-row class="text-center">
                <div
                  class="w-100 d-flex align-items-center justify-content-center"
                >
                  <div
                    style="
                      color: #b79143;
                      text-align: right;
                      font-size: 1.5rem;
                      margin-right: 1.5rem;
                    "
                  >
                    您也可以进行
                  </div>
                  <div style="cursor: pointer" @click="test_rst">
                    <b-img style="width: 14.06rem" :src="tiyan"></b-img>
                  </div>
                </div>
              </b-row>
              <br />
              <b-row class="text-center">
                <b-col cols="2"></b-col>
                <b-col cols="8" :style="title">
                  <div
                    style="
                      font-size: 2.5rem;
                      color: #ffffff;
                      line-height: 11rem;
                    "
                  >
                    追溯码怎么看？
                  </div>
                  <br />
                </b-col>
                <b-col cols="2"></b-col>
              </b-row>
              <br />

              <b-row style="color: #f2708c; font-size: 1.5rem">
                <b-col cols="4">
                  <div
                    style="
                      background-color: #fff;
                      padding: 15px;
                      border-radius: 5px;
                    "
                  >
                    <b-row>
                      <b-col>
                        <b-img :src="g1p" fluid-grow></b-img>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row class="text-center">
                      <b-col> 贴码样式 </b-col>
                    </b-row>
                  </div>
                </b-col>
                <b-col cols="4">
                  <div
                    style="
                      background-color: #fff;
                      padding: 15px;
                      border-radius: 5px;
                    "
                  >
                    <b-row>
                      <b-col>
                        <b-img :src="g2p" fluid-grow></b-img>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row class="text-center">
                      <b-col> 刻码样式 </b-col>
                    </b-row>
                  </div>
                </b-col>
                <b-col cols="4">
                  <div
                    style="
                      background-color: #fff;
                      padding: 15px;
                      border-radius: 5px;
                    "
                  >
                    <b-row>
                      <b-col>
                        <b-img :src="g3p" fluid-grow></b-img>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row class="text-center">
                      <b-col> 印刷码样式 </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col md="3"></b-col>
        </b-row>
      </b-container>
    </div>
    <!-- PC端结束 -->
  </div>
</template>

<script>


export default {
  name: "HomeView",
  // components: {
  // 	HelloWorld
  // },
  data() {
    return {
      txtcode: "",
      tiyan: require("../assets/page2/微信图片_20220523131949.png"),
      h300m: require("../assets/page2/h300m.gif"),
      h360m: require("../assets/page2/h360m.gif"),
      logo: require("../assets/page2/logo.png"),
      g1: require("../assets/page2/版本1.png"),
      g2: require("../assets/page2/版本2.png"),
      g3: require("../assets/page2/版本3.png"),
      g1p: require("../assets/page2/罐装版本一.png"),
      g2p: require("../assets/page2/罐装版本二.png"),
      g3p: require("../assets/page2/盒装版本.png"),
      qrcode: require("../assets/page2/二维码.png"),
      arrow: require("../assets/page2/箭头.png"),
      bottom: require("../assets/mobile_scan/botom.jpg"),

      bottomp: require("../assets/page2/底部牛奶组.png"),

      scan: require("../assets/page2/scan-btn.png"),
      line: require("../assets/page2/line.png"),
      note: {
        backgroundImage:
          "url('" + require("../assets/page2/图层 0.png") + "')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      },
      note_p: {
        backgroundImage:
          "url('" + require("../assets/pc_scan/bg11.png") + "')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      },
      topback: {
        backgroundPosition: "top",
        backgroundImage:
          "url('" + require("../assets/mobile_scan/top_bg.png") + "')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      },
      MobileTopbg: {
        width: "100%",
        height: "50rem",
        backgroundPosition: "top",
        backgroundImage:
          "url('" + require("../assets/mobile_scan/top_bg.png") + "')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      },
      title: {
        backgroundPosition: "center",
        backgroundImage:
          "url('" + require("../assets/page2/图层 9.png") + "')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      },
      weixin: false,
      ifMobile: false,
      scanResult:""  // 扫码返回的接口
    };
  },
  mounted() {
    // 企微
    if (this.$wechat.isWxwork()) {
      alert("请在微信打开");
    }
    // weixin
    if (this.$wechat.isWechat()) {
      this.weixin = true;
      // 小程序跳转jssdk
      // this.getConfig();
    } else {
      this.weixin = false;
    }
    console.log("this.$wechat.browser()", this.$wechat.browser());
    // document.body.clientWidth < 787
    if (
      this.$wechat.browser().mobile ||
      this.$wechat.browser().android ||
      this.$wechat.browser.ios
    ) {
      // 判断是否是移动端
      this.ifMobile = true;
    } else {
      console.log("这里是pc端");
      this.ifMobile = false;
    }

    window.addEventListener("resize", () => {
      if (
        this.$wechat.browser().mobile ||
        this.$wechat.browser().android ||
        this.$wechat.browser.ios
      ) {
        // 判断是否是移动端
        console.log("这里是移动端");
        this.ifMobile = true;
      } else {
        console.log("这里是pc端");
        this.ifMobile = false;
      }
    });
  },
  methods: {
    scancode() {
      this.$wechat.scanQRCode((res)=>{
          this.scanResult = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          console.log(this.scanResult);

          let host = "a.beingmate.com";
          if (res.resultStr.search(host) > 0) {
            // 取最后12位
            this.txtcode = res.resultStr.substring(res.resultStr.length - 12);
            if (this.txtcode == "" || this.txtcode == null) {
              alert("请先扫追溯码~");
              return false;
            }
            window.location.href = this.scanResult
            // this.goto_rst();
          } else {
            alert("追溯码不正确哦！");
          }
      })

    },

    goto_rst() {
      if (this.txtcode == "" || this.txtcode == null) {
        alert("请先扫码或手动填写追溯码~");
        return false;
      }
      console.log(this.txtcode.length)
      if (this.txtcode.length != 12) {
        alert("请正确填写12位追溯码哦~");
        return false;
      }

      // 通过码取到url
      this.getFullUrl()
    },



    test_rst() {
      var items = ["118579131810", "131113155326", "119298391409"];
      this.txtcode = items[Math.floor(Math.random() * items.length)];
      this.getFullUrl()
    },


    getFullUrl(){
      console.log(this.txtcode);
      window.location.href = "https://beingmate-scrm-v2.beingmate.com/api/bymwechat/code/reload?code="+this.txtcode
    }
    
  },
};
</script>
<style scoped="scoped">
/* 未被访问的链接 */
a:link {
  color: #f2708c;
}

/* 已被访问的链接 */
a:visited {
  color: #f2708c;
}

/* 将鼠标悬停在链接上 */
a:hover {
  color: #f2708c;
}

/* 被选择的链接 */
a:active {
  color: #f2708c;
}

input:focus {
  outline: none;
}
.footer-text {
  width: 100%;
  text-align: center;
  font-size: 2.5rem;
  font-family: FZZhengHeiS-B-GB;
  font-weight: 400;
  color: #f2708c;
  line-height: 32px;
  padding-top: 7.25rem;
}

.moveUpdown {
  position: absolute;
  top: 35px;
  left: 0;
  animation: fadenum ease-in-out 2.5s infinite;
}
@keyframes fadenum {
  50% {
    transform: translateY(55px);
  }
}
</style>
